(function () {
  'use strict';
  var configEl = document.querySelector('[data-newsletter-config]');
  if (!configEl) return;
  var config;
  try { config = JSON.parse(configEl.textContent); } catch (error) { return; }
  var code = String(config.code || '').trim();
  var root = (config.root || '/').replace(/\/?$/, '/');
  var popup = document.querySelector('[data-newsletter-popup]');
  var reopen = document.querySelector('[data-newsletter-reopen]');
  function syncPill() {
    if (reopen) reopen.hidden = !popup || popup.open || designMode || popup.dataset.subscriber === 'true' || get('localStorage', subscribedKey) === 'true' || !get('localStorage', shownKey);
  }
  var pendingKey = 'lif:newsletter:pending:v2';
  var offerKey = 'lif:newsletter:offer:v1';
  var shownKey = 'lif:newsletter:shown:v1';
  var subscribedKey = 'lif:newsletter:subscribed:v1';
  var ttl = 1800000;
  var previousOverflow = '';
  var opened = false;
  var timer;
  var checkoutBusy = false;
  var designMode = window.Shopify && window.Shopify.designMode;
  var state = popup && popup.querySelector('[data-newsletter-state]');
  function get(storage, key) { try { return window[storage].getItem(key); } catch (error) { return null; } }
  function set(storage, key, value) { try { window[storage].setItem(key, value); } catch (error) {} }
  function remove(storage, key) { try { window[storage].removeItem(key); } catch (error) {} }
  function record(key) {
    var value;
    try { value = JSON.parse(get('sessionStorage', key) || 'null'); } catch (error) {}
    if (!value || !Number.isFinite(value.time) || Date.now() - value.time > ttl || value.time > Date.now()) {
      remove('sessionStorage', key);
      return null;
    }
    return value;
  }
  function offer() {
    var value = record(offerKey);
    if (!code || !value || value.code !== code) return null;
    return value;
  }
  function remember() { if (!designMode) set('localStorage', shownKey, String(Date.now())); }
  function open(manual) {
    if (!popup || typeof popup.showModal !== 'function' || popup.open) return;
    if (!manual && (opened || popup.dataset.subscriber === 'true' || get('localStorage', subscribedKey) === 'true')) return;
    previousOverflow = document.body.style.overflow;
    popup.classList.remove('is-closing');
    window.clearTimeout(timer);
    popup.showModal();
    syncPill();
    document.body.style.overflow = 'hidden';
    opened = true;
    remember();
  }
  function closePopup() {
    if (!popup || !popup.open || popup.classList.contains('is-closing')) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) { popup.close(); return; }
    popup.classList.add('is-closing');
    window.setTimeout(function () { popup.close(); popup.classList.remove('is-closing'); }, 140);
  }
  function showStatus(applied) {
    document.querySelectorAll('[data-welcome-discount-status]').forEach(function (el) {
      el.hidden = false;
      el.textContent = applied ? config.applied : config.ready;
    });
  }
  async function cartJSON(path, options) {
    var response = await fetch(root + path, Object.assign({headers: {'Accept': 'application/json'}, credentials: 'same-origin'}, options));
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }
  function discountCodes(cart) {
    var codes = (cart.discount_codes || []).map(function (discount) { return discount.code; }).filter(Boolean);
    if (!codes.some(function (value) { return value.toUpperCase() === code.toUpperCase(); })) codes.push(code);
    return codes;
  }
  function hasAppliedDiscount(cart) {
    function matches(application, amount) {
      return application && String(application.title || application.code || '').toUpperCase() === code.toUpperCase() && Number(amount) > 0;
    }
    return (cart.cart_level_discount_applications || []).some(function (application) {
      return matches(application, application.total_allocated_amount);
    }) || (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (allocation) {
        return matches(allocation.discount_application, allocation.amount);
      });
    });
  }
  async function attachDiscount(cart) {
    var updated = await cartJSON('cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({discount: discountCodes(cart).join(',')})});
    showStatus(hasAppliedDiscount(updated));
    document.dispatchEvent(new CustomEvent('lif:cart:updated', {detail: updated}));
    return updated;
  }
  function simpleCart(cart) {
    var ids = new Set();
    if (!cart.items || !cart.items.length || cart.note || Object.keys(cart.attributes || {}).length) return false;
    return cart.items.every(function (item) {
      if (item.selling_plan_allocation || Object.keys(item.properties || {}).length || ids.has(item.variant_id)) return false;
      ids.add(item.variant_id);
      return Number.isSafeInteger(item.variant_id) && Number.isSafeInteger(item.quantity) && item.quantity > 0;
    });
  }
  function checkoutURL(cart, saved) {
    if (simpleCart(cart) && saved.email) {
      var lines = cart.items.map(function (item) { return item.variant_id + ':' + item.quantity; }).join(',');
      var params = new URLSearchParams();
      params.set('checkout[email]', saved.email);
      if (cart.note) params.set('note', cart.note);
      params.set('discount', discountCodes(cart).join(','));
      return root + 'cart/' + lines + '?' + params.toString();
    }
    return root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'checkout');
  }
  function checkoutError(form, message) {
    var el = form.querySelector('[data-welcome-checkout-error]') || document.querySelector('[data-welcome-checkout-error]');
    if (el) { el.hidden = false; el.textContent = message; }
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || designMode) return;
    var tags = form.querySelector('input[name="contact[tags]"]');
    if (tags && tags.value.split(',').some(function (tag) { return tag.trim() === 'newsletter'; })) {
      var email = form.querySelector('input[name="contact[email]"]');
      if (!email || !form.checkValidity()) return;
      if (form.getAttribute('aria-busy') === 'true') { event.preventDefault(); return; }
      set('sessionStorage', pendingKey, JSON.stringify({source: form.id === 'LifNewsletterPopupForm' ? 'popup' : 'footer', email: email.value.trim(), time: Date.now()}));
      form.setAttribute('aria-busy', 'true');
      var submit = form.querySelector('button[type="submit"], button:not([type]), input[type="submit"]');
      if (submit && submit.tagName === 'BUTTON') {
        submit.dataset.originalLabel = submit.textContent;
        submit.textContent = config.submitting;
        submit.disabled = true;
      }
      return;
    }
    var button = event.submitter;
    var saved = offer();
    if (!saved || !button || button.name !== 'checkout' || (form.getAttribute('method') || '').toLowerCase() !== 'post') return;
    if (new URL(form.action, location.href).pathname.replace(/\/$/, '') !== (root + 'cart').replace(/\/$/, '')) return;
    event.preventDefault();
    if (checkoutBusy) return;
    if (window.LIF && window.LIF.cartPending) { checkoutError(form, config.checkoutError); return; }
    checkoutBusy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    document.querySelectorAll('[data-welcome-checkout-error]').forEach(function (el) { el.hidden = true; });
    (async function () {
      if (window.LIF && window.LIF.saveOrderNote) await window.LIF.saveOrderNote();
      var inputs = form.querySelectorAll('[data-qty-input][data-key]');
      if (inputs.length) {
        var updates = {};
        inputs.forEach(function (input) {
          var quantity = Number(input.value);
          if (!Number.isSafeInteger(quantity) || quantity < 0 || input.value.trim() === '') throw new Error('Invalid quantity');
          updates[input.dataset.key] = quantity;
        });
        await cartJSON('cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({updates: updates})});
      }
      var cart = await cartJSON('cart.js');
      if (!cart.item_count) { checkoutError(form, config.emptyCart); return; }
      try { cart = await attachDiscount(cart); } catch (error) { showStatus(false); }
      location.assign(checkoutURL(cart, saved));
    })().catch(function () { checkoutError(form, config.checkoutError); }).finally(function () {
      checkoutBusy = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
  }, true);
  if (reopen) reopen.addEventListener('click', function () { open(true); });
  if (popup) {
    popup.addEventListener('close', function () { document.body.style.overflow = previousOverflow; remember(); syncPill(); });
    popup.querySelectorAll('[data-newsletter-close]').forEach(function (button) { button.addEventListener('click', closePopup); });
    popup.addEventListener('cancel', function (event) { event.preventDefault(); closePopup(); });
    popup.addEventListener('click', function (event) {
      if (event.target !== popup) return;
      var rect = popup.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closePopup();
    });
    document.addEventListener('shopify:section:select', function (event) { if (designMode && event.detail.sectionId === popup.dataset.sectionId) open(true); });
  }
  var pending = record(pendingKey);
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('form[aria-busy="true"]').forEach(function (form) {
      form.removeAttribute('aria-busy');
      var submit = form.querySelector('[data-original-label]');
      if (submit) { submit.textContent = submit.dataset.originalLabel; submit.disabled = false; }
    });
  });
  var confirmed = state && state.dataset.newsletterState === 'success' || document.querySelector('[data-newsletter-confirmed]');
  if (confirmed && !designMode) {
    set('localStorage', subscribedKey, 'true');
    if (pending) set('sessionStorage', offerKey, JSON.stringify({email: pending.email, code: code, time: Date.now()}));
    remove('sessionStorage', pendingKey);
    if (!pending || pending.source === 'popup') open(true);
  } else if ((state && state.dataset.newsletterState === 'error' || document.querySelector('[data-newsletter-error]')) && pending) {
    remove('sessionStorage', pendingKey);
    if (pending.source === 'popup') open(true);
  }
  if (offer() && !designMode) {
    showStatus(false);
    cartJSON('cart.js').then(function (cart) { if (cart.item_count) return attachDiscount(cart); }).catch(function () { showStatus(false); });
  }
  syncPill();
  if (!popup || confirmed || designMode || popup.dataset.autoAllowed !== 'true' || popup.dataset.subscriber === 'true' || get('localStorage', subscribedKey) === 'true') return;
  var frequency = Math.max(1, Number(popup.dataset.frequency) || 7) * 86400000;
  var delay = Math.min(30, Math.max(2, Number(popup.dataset.delay) || 4)) * 1000;
  var lastShown = Number(get('localStorage', shownKey)) || 0;
  if (lastShown && Date.now() - lastShown < frequency) return;
  var clockKey = 'lif:newsletter:visit-start:v1';
  var started = Number(get('sessionStorage', clockKey));
  if (!started || started > Date.now() || Date.now() - started > ttl) {
    var pageElapsed = window.performance && typeof window.performance.now === 'function' ? window.performance.now() : 0;
    started = Date.now() - pageElapsed;
    set('sessionStorage', clockKey, String(started));
  }
  var lastInputAt = 0;
  document.addEventListener('input', function () { lastInputAt = Date.now(); }, {passive: true});
  function attempt() {
    var focus = document.activeElement;
    var occupied = document.querySelector('dialog[open], #drawer.on, #mm.on, [role="dialog"][aria-modal="true"][aria-hidden="false"]');
    var typing = focus && focus.matches('input, textarea, select, [contenteditable="true"]') && Date.now() - lastInputAt < 2000;
    if (document.hidden || occupied || typing) {
      timer = window.setTimeout(attempt, 250);
      return;
    }
    open(false);
  }
  timer = window.setTimeout(attempt, Math.max(0, delay - (Date.now() - started)));
  window.addEventListener('pagehide', function () { window.clearTimeout(timer); });
})();
